<template>
  <footer class="archive-footer">
    <div class="footer-rule"></div>
    <div class="footer-content">
      <p class="footer-thanks">Thank you for visiting The Ephemera Archive</p>
      <p class="footer-tagline">Every visitor leaves a trace. Yours is now part of our collection.</p>
      <div class="footer-meta">
        <span v-if="sessionId" class="footer-session">Session {{ sessionId }}</span>
        <span class="footer-separator">&middot;</span>
        <span class="footer-experiment">An experiment in digital natural history</span>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useArchiveStore } from '../../stores/archive';

const archiveStore = useArchiveStore();
const sessionId = computed(() => archiveStore.sessionId?.slice(0, 8) || null);
</script>

<style scoped>
.archive-footer {
  background-color: var(--color-sepia-medium);
  padding: 0 var(--spacing-xl) var(--spacing-2xl);
  margin-top: auto;
}

.footer-rule {
  height: 2px;
  margin-bottom: var(--spacing-2xl);
  background: linear-gradient(
    90deg,
    transparent,
    var(--color-black-primary) 20%,
    var(--color-burgundy) 50%,
    var(--color-black-primary) 80%,
    transparent
  );
  opacity: 0.3;
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  text-align: center;
}

.footer-thanks {
  font-family: var(--font-serif);
  font-size: 1.25rem;
  color: var(--color-black-primary);
  margin: 0 0 var(--spacing-sm);
}

.footer-tagline {
  font-family: var(--font-serif);
  font-size: 0.95rem;
  font-style: italic;
  color: var(--color-text-muted);
  margin: 0 0 var(--spacing-lg);
}

.footer-meta {
  font-size: 0.8rem;
  color: var(--color-text-disabled);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
}

.footer-session {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 0.75rem;
}

.footer-separator {
  opacity: 0.5;
}

@media (max-width: 768px) {
  .archive-footer {
    padding: 0 var(--spacing-md) var(--spacing-xl);
  }

  .footer-meta {
    flex-direction: column;
    gap: var(--spacing-xs);
  }

  .footer-separator {
    display: none;
  }
}
</style>
